export default {"src":"/_next/static/media/avalanche-logo.c97e5815.svg","height":48,"width":238};